export default __webpack_public_path__ + "logo.97ed985a.svg";